<template>
    <p  class="py-1 info-tag-item">
      <strong>{{ name }}:</strong>
    </p>
    <p  class="value p-1 info-tag-item">
      {{ value }}
    </p>
</template>

<script>
export default {
  name: 'InfoTagsItem',
  props: {
    tag: {
      type: Object,
      required: true
    }
  },
  computed: {
    name () {
      return this.tag.friendlyName || this.tag.name
    },
    value () {
      const hasValue = Object.hasOwn(this.tag, "value")
      const lowerBound = (Object.hasOwn(this.tag, "lowerBound")) 
        ? `${this.tag.prefix || ''}${this.pad(this.tag.lowerBound)}${this.tag.suffix || ''}`
        : '';
      const upperBound = (Object.hasOwn(this.tag, "upperBound"))
        ? `${this.tag.prefix || ''}${this.pad(this.tag.upperBound)}${this.tag.suffix || ''}`
        : ''

      if (lowerBound && upperBound && !hasValue) {
        return lowerBound + (upperBound ? ` - ${upperBound}` : '')
      }
      else if (hasValue) {
        return this.tag.value
      }
      return ""
    }
  },
  methods: {
    pad (value) {
      const numericSize = this.tag.numericSize && this.tag.numericSize > value.toString().length
        ? this.tag.numericSize
        : 0
      return new Array(numericSize).concat([Math.abs(value)]).join('0').slice(-numericSize)
    }
  }
}
</script>
<style scoped>
.info-tag-item {
  border-bottom: 1px solid lightgrey;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}
</style>
